/**
 * BannerListContainer
 * --
 */
import React from 'react';
import BannerListPresenter from './BannerListPresenter';

const BannerListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <BannerListPresenter />
    </>
  );
};

export default BannerListContainer;
